import { BillingMainComponent } from '../../components/dashboard/loggedin-content/billing/billing-main.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AutopayBillingService } from '../../_services/my-insurance/autopay-billing.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BillingMainComponent],
  selector: 'app-billing',
  templateUrl: './billing.component.html',
})
export class BillingComponent implements OnInit {
  showAlertNotification = false;
  hideAlert = false;

  constructor(private autopayBillingService: AutopayBillingService) {}

  ngOnInit() {
    this.autopayBillingService.getAutopayAlert().subscribe((show) => {
      this.showAlertNotification = show;
    });
  }

  onClose(){
    this.hideAlert = true;
  }
}
